module.exports = __webpack_public_path__ + "static/media/image.d7539194.svg";